export const iconFontAwesomeArrowsCircleArrowUp = (
	<i className="fa-solid fa-circle-arrow-up"></i>
);
